import React, { useEffect } from "react";
import { useTriviaLottery } from "../../hooks/useTriviaLottery";

import { formatTime } from "../../../utils/formatTime";
import { defPath } from "../../config/defPath";

const FinishTrivia = ({result}: {result:any}) => {
  const milliseconds = useTriviaLottery(state => state.trivia.milliseconds)
  const maxquestions = useTriviaLottery(state => state.trivia.maxquestions)
  const currentTime = useTriviaLottery(state => state.currentTime)
  const resultsRender = useTriviaLottery(state => state.trivia.results)

  useEffect(() => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content',
      'event_label': `${result.correct}/${maxquestions}`,
      'interaction':'true',
      'component_name': 'Modo_Carrera_TriviaLottery',
      'element_text': formatTime(currentTime),
    });
  }, [])

  function handleClickFinishTrivia(e:any) {
    e.preventDefault()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `Successful Quiz - Return stadium`,
      'interaction':'true',
      'component_name': 'Modo_Carrera_TriviaLottery',
      'element_text': 'Ir al estadio',
    });

    if (e.currentTarget.href) window.location.href = e.currentTarget.href
  }

  return (
    <section className="lottery-trivia_finish blur-in">
      <picture className='lottery-trivia_logo'>
        <img className='lottery-trivia_logo--img' src={`${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Estadio Aguila" title="Logo Estadio Aguila" />
      </picture>

      <p className="lottery-trivia_title whiteShadow" dangerouslySetInnerHTML={{ __html: resultsRender?.title?.value }}></p>

      <section className="lottery-trivia_result-box">
        <div>
          <p className="lottery-trivia_subtitle whiteShadow">Acertaste:</p>
          <p className="lottery-trivia_result-text">{result.correct}/{maxquestions} preguntas</p>
        </div>

        <div>
          <p className="lottery-trivia_subtitle whiteShadow">Tu tiempo fue de: </p>
          <p className="lottery-trivia_result-text">{formatTime(currentTime)}</p>
        </div>
      </section>

      <p className="lottery-trivia_message whiteShadow" dangerouslySetInnerHTML={{ __html: resultsRender?.copy?.value }}></p>

      <div className='lottery-trivia_btn-container'>
        <a className='newBottom--smallYellow lottery-trivia_landing-btn' onClick={handleClickFinishTrivia} href={resultsRender?.button?.uri}>{resultsRender?.button?.title}</a>
      </div>
    </section>
  )
}

export default FinishTrivia